import { format, parse } from "date-fns";
import { ja } from "date-fns/locale";

/**
 * 日付サービスクラス
 */
class DateService {
  /**
   * 現在の日時をフォーマットする
   * @param {string} [formatString="yyyy/MM/dd HH:mm:ss"] フォーマット文字列
   * @memberof DateService
   */
  formatCurrentDatetime(formatString = "yyyy/MM/dd HH:mm:ss") {
    return format(new Date(), formatString, { locale: ja });
  }
  /**
   * DB の日付時刻文字列をフォーマットする
   * @param {string} dateStr 日付時刻文字列
   * @param {string} [formatString="yyyy年M月d日 HH:mm"] フォーマット文字列
   * @memberof DateService
   */
  formatDBDatetime(dateStr, formatString = "yyyy年M月d日 H:mm") {
    if (!dateStr) return "";
    return format(
      parse(dateStr, "yyyy/MM/dd HH:mm:ss", new Date()),
      formatString,
      { locale: ja },
    );
  }
}
export const dateService = new DateService();
